import { motion } from "framer-motion";
import { ReactNode } from "react";
import { fadeVariants, smoothAccelerationTransition } from "../../utils/routeAnimations";

interface AnimatedRouteProps {
  children: ReactNode;
}

export const AnimatedRoute = ({ children }: AnimatedRouteProps) => {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={fadeVariants}
      transition={smoothAccelerationTransition}
      className="h-full w-full"
    >
      {children}
    </motion.div>
  );
};